app.views.session = app.views.base.extend({
  interval: new Object(),
  announcementData: new Object(),
  settings: {
    debug: false,
    notifyDuration: 3,
    // Minutes
    redirectUrl: '/auth/logout',
    pollingInterval: 30000,
    expiryCookie: '.PRAPayTimeoutCookie',
    format: 'YYYY-MM-DD hh:mm:ss'
  },
  attr: {
    modal: 'data-session-expiry'
  },
  init: function init() {
    moment.locale();
    this.initSessionTimeout();
  },
  initSessionTimeout: function initSessionTimeout() {
    this.pollSessionEndpoint();
  },
  pollSessionEndpoint: function pollSessionEndpoint() {
    var _this = this;
    this.interval.session = setInterval(function () {
      $.ajax({
        url: '/api/session/timeout',
        method: 'GET',
        success: function success(data) {
          var currentTime = moment.utc(new Date()).format();
          var notifyTime = _this.getSessionExpiryNotifyDateTime(data.timeout);
          var expiryTime = moment(data.timeout).format();
          if (_this.settings.debug) {
            console.log('Current DateTime = ' + currentTime + ' --- Notify DateTime = ' + notifyTime);
          }
          if (currentTime >= notifyTime) {
            _this.showSessionExpiryNotification();
            if (_this.settings.debug) {
              console.log('Current DateTime = ' + currentTime + ' --- Notify DateTime = ' + notifyTime);
            }
            if (currentTime >= expiryTime) {
              window.location.href = _this.settings.redirectUrl;
            }
          }
        }
      });
    }, this.settings.pollingInterval);
  },
  showSessionExpiryNotification: function showSessionExpiryNotification() {
    $.magnificPopup.open({
      items: {
        src: '[' + this.attr.modal + ']'
      },
      type: 'inline'
    });
  },
  onStaySignedIn: function onStaySignedIn(data) {
    if (this.settings.debug) {
      console.log('Timeout refreshed: ' + data.timeout);
    }
    $.magnificPopup.close();
  },
  getSessionCookieValue: function getSessionCookieValue(cookie) {
    var arr = document.cookie.split(';');
    for (var i = 0; i < arr.length; i++) {
      var val = arr[i].split('=');
      if (cookie === val[0].trim()) {
        return decodeURIComponent(val[1]);
      }
    }
  },
  getSessionExpiryNotifyDateTime: function getSessionExpiryNotifyDateTime(expiry) {
    return moment(expiry).subtract(this.settings.notifyDuration, 'minutes').format();
  }
});